export const AB_TESTING_DATA_FOR_AUTHORIZED_USER_STORAGE_KEY = "cgp_ABTestingDataForUser";
export const AB_TESTING_ANONYMOUS_PLAYER_ID_STORAGE_KEY = "cgp_ABTestingAnonymousPlayerId";